// (function ($) {
//     var addClass = $.fn.addClass;
//     var removeClass = $.fn.removeClass;
    
//     var filter = function (item) {
//         return item;
//     };
    
//     var diff = function (a1, a2) {
//         return a1.filter(function(i) {
//             return a2.indexOf(i) < 0;
//         }).concat(a2.filter(function (i) {
//             return a1.indexOf(i) < 0;
//         }));
//     };
    
//     $.fn.addClass = function () {
//         var _this = this,
//             before, after, changed;
        
//         before = this.is('[class]') ? this.attr('class').split(/\s+/).filter(filter) : [];
//         addClass.apply(_this, arguments);
//         after = this.is('[class]') ? this.attr('class').split(/\s+/).filter(filter) : [];
        
//         changed = diff(before, after);
        
//         if (changed.length) {
//             _this.each(function () {
//                 var $this  =$(this);
                
//                 $this.triggerHandler('classAdd', [changed]);
//                 $this.triggerHandler('classChange', ['added', changed]);
//             });
//         }
        
//         return _this;
//     };
    
//     $.fn.removeClass = function () {
//         var _this = this;
//         var before, after, changed;
        
//         before = this.is('[class]') ? this.attr('class').split(/\s+/).filter(filter) : [];
//         removeClass.apply(this, arguments);
//         after = this.is('[class]') ? this.attr('class').split(/\s+/).filter(filter) : [];
        
//         changed = diff(before, after);
        
//         if (changed.length) {
//             _this.each(function () {
//                 var $this  =$(this);
                
//                 $this.triggerHandler('classRemove', [changed]);
//                 $this.triggerHandler('classChange', ['removed', changed]);
//             });
//         }
        
//         return this;
//     };
// })(jQuery);
